export default {
  functionKey: "CHERCHE",
  title: "CHERCHE",
  group: "Texte",
  origin: [],
  target: [],
  arguments: [],
  maxArguments: 1,
  requiredArguments: [{ argumentKey: "Search", name: "Texte recherché" }],
  expectedArguments: [
    { name: "Texte recherché", argumentKey: "Search", single: true, initialValue: "" }
  ],
  description: "Retourne la position d'un texte dans un autre. (Ex: CHERCHE('helloworld', 'world') -> 5)",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = ${origin}.indexOf(${args[0]});`;
    return { displayCode: code, safeCode: code };
  }
}
